import axios from 'axios';
import signature from '@/services/signature';

const BASE_URI = process.env.VUE_APP_API_BASE_URI;

/*
  Public preview catalogue — signature only, no auth.

  These endpoints don't carry an Authorization header on purpose: the
  /api/v1/preview/* family is reachable by anonymous visitors and is
  authenticated solely by the HMAC signature appended via signature().
  Adding a Bearer token here would still work, but it'd defeat the
  "browseable to the public" contract these endpoints exist for.
*/
const config = {
  headers: {
    TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
  }
};

class PreviewProductsApi {
  /**
   * GET /v1/preview/products
   * Query (all optional): search, product_category_id, sort ("field|asc"|"field|desc").
   * Sending any other query key (besides key/timestamp/signature)
   * returns 422 NotAllowedRule.
   */
  async list(queryString = '') {
    const response = await axios.get(
      BASE_URI + '/v1/preview/products' + signature(queryString),
      config
    );
    return response;
  }

  /**
   * GET /v1/preview/branches/{code}/products
   * Branch-scoped catalogue: only products the branch sells (is_active),
   * each carrying an `is_in_stock` flag (same out-of-stock definition as
   * the POS/Service menu). Same query params as list().
   */
  async listByBranch(code, queryString = '') {
    const response = await axios.get(
      BASE_URI + '/v1/preview/branches/' + encodeURIComponent(code) + '/products' + signature(queryString),
      config
    );
    return response;
  }

  /**
   * GET /v1/preview/products/{productId}
   * Returns full product with attributes/variants/modifiers (each wrapped
   * in `{ data: [...] }` envelopes, unlike the list response). Callers
   * should unwrap via `normalizeDetail` in the component.
   */
  async info(productId) {
    const response = await axios.get(
      BASE_URI + '/v1/preview/products/' + productId + signature(),
      config
    );
    return response;
  }
}

export const PreviewProducts = new PreviewProductsApi();
